import { RejectApprovalFlowActivity } from 'modules/approvals/activities/RejectApprovalFlow'
import { CompanyLinksEditActivity } from 'modules/dashboard/activities/CompanyLinksEdit'
import { TeamStatusActivity } from 'modules/dashboard/activities/TeamStatus'
import { DiscardTaskActivity } from 'modules/inbox_tasks/activities/DiscardTask'
import { NoPermissionTaskActivity } from 'modules/inbox_tasks/activities/NoPermissionTask'
import { TaskActivity } from 'modules/inbox_tasks/activities/Task'
import { NotificationActivity } from 'modules/notifications/activities/Activity'
import { EmployeeTest } from 'modules/playground/activities/EmployeeTest'

import { sidebarManifest } from './sidebar'
import type { DomainManifest } from './types'

export const manifest = {
  sidebar: (navigation) => ({
    items: sidebarManifest(navigation),
  }),
  activities: {
    rejectApprovalFlow: {
      component: RejectApprovalFlowActivity,
      guidelines:
        'Opens the reject-approval-flow overlay to reject an approval flow with an optional reason. Use when the user wants to reject an approval request or approval flow.',
      params: {
        materializedFlowId: { guidelines: 'The ID of the materialized approval flow to reject.' },
        taskId: { guidelines: 'The ID of the task associated with the approval flow.' },
      },
    },
    dashboardTeamStatus: {
      component: TeamStatusActivity,
      guidelines:
        'Opens the team status overlay filtered by clock-in state (who should not be working, missing clock-in, or currently working). Use when the user asks about team status, who is working, who forgot to clock in, or who should not be working.',
      params: {
        status: {
          guidelines: 'Filter to apply: should_not_be_working | missing_clock_in | working.',
        },
      },
    },
    dashboardCompanyLinksEdit: {
      component: CompanyLinksEditActivity,
      guidelines:
        'Opens the company links edit modal to add or edit company link resources. Use when the user wants to add, edit, or manage company links (resources) on the dashboard.',
      availableForOne: true,
    },
    employeeTest: {
      component: EmployeeTest,
      guidelines:
        'Opens the playground employee test activity to display an employee by ID (development only). Use for development/testing when the user asks to open the employee test overlay.',
      params: {
        employeeId: { guidelines: 'The ID of the employee to display.' },
      },
    },
    notificationsActivity: {
      component: NotificationActivity,
      guidelines:
        'Opens the notifications panel to view and manage inbox notifications. Use when the user asks to see notifications, open the notification center, or check their notifications.',
      availableForOne: true,
    },
    task: {
      component: TaskActivity,
      guidelines:
        'Opens a task from the inbox in an overlay to view details and take action. Use when the user asks to open a specific inbox task, view task details, or work on a task.',
      params: {
        id: { guidelines: 'The ID of the inbox task to open.' },
      },
    },
    discardTask: {
      component: DiscardTaskActivity,
      guidelines:
        'Opens the discard-task overlay to confirm discarding an outdated inbox task. Use when the user wants to discard or remove an outdated inbox task.',
      params: {
        id: { guidelines: 'The ID of the inbox task to discard.' },
      },
    },
    noPermissionTask: {
      component: NoPermissionTaskActivity,
      guidelines:
        'Shows the no-permission task overlay when the user has no access to the task. Use when the user lacks permission to access a task.',
      params: {
        id: { guidelines: 'The ID of the inbox task the user cannot access.' },
      },
    },
  },
} as const satisfies DomainManifest
